(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hml-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (frame) => {
      if (frame.dataset.udhsReady) return;
      frame.dataset.udhsReady = '1';
      const slides = [...frame.querySelectorAll('[data-udhs-slide]')];
      const dots = [...frame.querySelectorAll('[data-udhs-dot]')];
      if (slides.length < 2) return;
      const DUR = 6000;
      frame.style.setProperty('--udhs-dur', DUR + 'ms');
      let i = 0, timer = null;
      const go = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k !== i); });
        dots.forEach((d, k) => { d.classList.remove('is-on'); void d.offsetWidth; d.classList.toggle('is-on', k === i); });
        restart();
      };
      const restart = () => {
        clearTimeout(timer);
        if (frame.dataset.autoplay === 'true' && !frame.classList.contains('is-paused')) timer = setTimeout(() => go(i + 1), DUR);
      };
      frame.querySelector('[data-udhs-prev]')?.addEventListener('click', () => go(i - 1));
      frame.querySelector('[data-udhs-next]')?.addEventListener('click', () => go(i + 1));
      dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
      frame.addEventListener('mouseenter', () => { frame.classList.add('is-paused'); clearTimeout(timer); });
      frame.addEventListener('mouseleave', () => { frame.classList.remove('is-paused'); go(i); });
      let x0 = null;
      frame.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      frame.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      });
      restart();
    };
    const run = () => document.querySelectorAll('[data-udhs]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hml-vitrine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.udvtReady) return;
      root.dataset.udvtReady = '1';
      const tabs = root.querySelectorAll('[data-udvt-tab]');
      const panels = root.querySelectorAll('[data-udvt-panel]');
      const more = root.querySelector('[data-udvt-more]');

      const bindPanel = (panel) => {
        const track = panel.querySelector('[data-udvt-track]');
        if (!track || track.dataset.udvtBound) return;
        track.dataset.udvtBound = '1';
        const foot = panel.querySelector('.udvt__foot');
        const thumb = panel.querySelector('[data-udvt-thumb]');
        const prev = panel.querySelector('[data-udvt-prev]');
        const next = panel.querySelector('[data-udvt-next]');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          foot.classList.toggle('is-static', max <= 2);
          const pct = max > 0 ? track.scrollLeft / max : 0;
          thumb.style.width = (ratio * 100) + '%';
          thumb.style.transform = 'translateX(' + (pct * (1 / ratio - 1) * 100) + '%)';
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        };
        const step = () => {
          const card = track.firstElementChild;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card ? (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(track.clientWidth / (card.getBoundingClientRect().width + gap))) : track.clientWidth;
        };
        prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
        next.addEventListener('click', () => track.scrollBy({ left: step() }));
        track.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(track);
        update();
      };

      panels.forEach((p) => { if (p.classList.contains('is-on')) bindPanel(p); });
      tabs.forEach((t) => t.addEventListener('click', () => {
        const k = t.dataset.udvtTab;
        tabs.forEach((x) => { const on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        panels.forEach((p) => { const on = p.dataset.udvtPanel === k; p.classList.toggle('is-on', on); if (on) bindPanel(p); });
        if (more && t.dataset.udvtUrl) more.setAttribute('href', t.dataset.udvtUrl);
      }));
    };
    const run = () => document.querySelectorAll('.udvt').forEach(setup);
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
